module.exports = __webpack_public_path__ + "old1.jpg?cf38746bcc73db718acd0f977cb615f3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/old1.jpg
// module id = 79
// module chunks = 0